import { useQuery } from "@tanstack/react-query";

// const url = process.env.REACT_APP_URL_DIR + "user";
const urlProd = process.env.REACT_APP_URL_DIR + "giftcardtat/";

export function GetGiftcardtat() {
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["Giftcardtat"],
      queryFn: () =>
         fetch(urlProd, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         }).then((res) => res.json())
   });

   return data;
}

export function GetGiftcardtatIns() {
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["Giftcardtat"],
      queryFn: () =>
         fetch(urlProd, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         }).then((res) => res.json())
   });

   return data;
}
